// noinspection JSUnusedGlobalSymbols

import { accountsInfoSlice } from './accountsInfo.slice.ts';

export const { setAllGroups, setAccount, resetAccountsInfo, setLoadingState, setNonParcelMode } =
  accountsInfoSlice.actions;
